import { AuxiliumComponent } from "../auxilium-component";

export class List extends AuxiliumComponent {
	constructor() {
		super();

		this.ordered = this.hasAttribute("ordered");
		this.flush = this.hasAttribute("flush");
		this.gap = this.getAttribute("gap");
		this.clickable = this.hasAttribute("clickable");
		this.buttonPadding = this.getAttribute("button-padding");
	}

	addItem(item, list) {
		list ??= this.querySelector(":scope>ul, :scope>ol");

		if (list) {
			list.appendChild(document.createElementWithContents("li", item));
		}
	}

	removeItem(item) {
		if (item.parentElement?.nodeName === "LI") { item.parentElement.remove(); }
		else { item.remove(); }
	}

	parsedCallback() {
		const list = document.createElement(this.ordered ? "ol" : "ul");

		this.querySelectorAll(":scope > chip-listitem").forEach(item => this.addItem(item, list));

		if (this.flush) { list.classList.add("list-flush"); }
		if (this.gap) { list.classList.add(`spaced-list--${this.gap}`); }

		this.appendChild(list);
	}
}